import Footer from 'components/Footer';
import OrganizationHeader from 'components/OrganizationHeader';
import { useQuery } from '@tanstack/react-query';
import { getHotelStatic } from 'api/hotelApi';
import { useEffect } from 'react';
import { hotelAction } from 'src/redux/actions';
import { useDispatch } from 'react-redux';
import ScrollTop from 'src/components/ScrollTop';

type HotelLayoutProps = {
   children: any;
};

const OrganizationLayout = (props: HotelLayoutProps) => {
   const { children } = props;
   const dispatch = useDispatch();

   const { data } = useQuery({
      queryKey: ['getHotelStatic'],
      queryFn: getHotelStatic,
      retry: false,
      staleTime: Infinity,
   });


   useEffect(() => {
      if (data?.data) {
         dispatch(hotelAction.setHotelStatic(data?.data));
      }
   }, [data?.data]);

   return (
      <div className="flex-1 min-h-screen flex flex-col justify-between items-center bg-white">
         <ScrollTop />
         <OrganizationHeader />
         <div className="flex-1 w-full min-h-0">
            {children}
         </div>
         <Footer />
      </div>
   );
};

export default OrganizationLayout;
